/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class OperatorChatRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(OperatorChatRoute);
